(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for blocking agenda 
    module.controller('AgendaBlockModalController',
        ['$uibModalInstance', 'AgendaService', 'DateService', 'Alert', 'FastBlock', 'agendaId', AgendaBlockModalControllerFn]);

    function AgendaBlockModalControllerFn($uibModalInstance, AgendaService, DateService, Alert, FastBlock, agendaId) {
        var vm = this;

        // duration
        vm.duration = null;
        vm.description = null;

        // duration options
        vm.durations = [];

        activate();

        // cancel
        vm.cancel = function () {
            $uibModalInstance.close();
        };

        // activation work
        function activate() {
            // If it is the Current Day
            if (DateService.isToday()) {
                vm.durations.push(FastBlock.OneHour);
                vm.durations.push(FastBlock.TwoHours);
                vm.durations.push(FastBlock.RestOfDay);
                vm.duration = FastBlock.OneHour.value;
            }// if
            else {
                vm.durations.push(FastBlock.RestOfDay);
                vm.duration = FastBlock.RestOfDay.value;
            }
        } // activate

        // block agenda
        vm.block = function () {
            if (vm.description === undefined || vm.description === null) { vm.description = ""; }
            AgendaService.block(agendaId, vm.duration, vm.description).then(function (result) {
                $uibModalInstance.close();
                Alert.success(result);
            });
        };

    }

})();